// Copyright 1999-2017. Plesk International GmbH. All rights reserved.
var passwordScore = function passwordScore(password) {
  var unusedRules = [];
  var score = 0;
  Object.keys(rules).forEach(function (rule) {
    var mark = rules[rule](password);

    if (mark < 0) {
      unusedRules.push({
        rule: rule,
        value: -mark
      });
    } else {
      score += mark;
    }
  });
  return {
    score: score,
    unusedRules: unusedRules
  };
};

var rules = {
  passwordTooShort: function passwordTooShort(passwd) {
    return passwd.length < 5 ? -1 : 0;
  },
  passwordLength: function passwordLength(passwd) {
    if (passwd.length < 5) {
      return 3;
    }

    if (passwd.length > 4 && passwd.length < 8) {
      return 6;
    }

    if (passwd.length > 7 && passwd.length < 16) {
      return 12;
    }

    return 18;
  },
  lettersLowerCase: function lettersLowerCase(passwd) {
    // [verified] at least one lower case letter
    return passwd.match(/[a-z]/) ? 1 : -1;
  },
  lettersUpperCase: function lettersUpperCase(passwd) {
    // [verified] at least one upper case letter
    return passwd.match(/[A-Z]/) ? 5 : -1;
  },
  numbers1: function numbers1(passwd) {
    // [verified] at least one number
    return passwd.match(/\d+/) ? 5 : -1;
  },
  numbers3: function numbers3(passwd) {
    // [verified] at least three numbers
    return passwd.match(/(.*[0-9].*[0-9].*[0-9])/) ? 5 : -1;
  },
  specialChar1: function specialChar1(passwd) {
    // [verified] at least one special character
    return passwd.match(/[!@#$%^&*?_~]/) ? 5 : -1;
  },
  specialChar2: function specialChar2(passwd) {
    // [verified] at least two special characters
    return passwd.match(/(.*[!@#$%^&*?_~].*[!@#$%^&*?_~])/) ? 5 : -1;
  },
  comboUpperAndLower: function comboUpperAndLower(passwd) {
    // [verified] both upper and lower case
    return passwd.match(/([a-z].*[A-Z])|([A-Z].*[a-z])/) ? 2 : -1;
  },
  comboLettersAndNumbers: function comboLettersAndNumbers(passwd) {
    // [verified] both letters and numbers
    return passwd.match(/([a-zA-Z])/) && passwd.match(/([0-9])/) ? 2 : -1;
  },
  comboLettersNumbersSpecial: function comboLettersNumbersSpecial(passwd) {
    // [verified] letters, numbers, and special characters
    return passwd.match(/([a-zA-Z0-9].*[!@#$%^&*?_~])|([!@#$%^&*?_~].*[a-zA-Z0-9])/) ? 2 : -1;
  }
};
export default passwordScore;